import { render } from "./nebim.vue?vue&type=template&id=fbb25642"
import script from "./nebim.vue?vue&type=script&lang=js"
export * from "./nebim.vue?vue&type=script&lang=js"

import "./nebim.vue?vue&type=style&index=0&id=fbb25642&lang=css"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__